import { Card, CardContent, Typography } from "@mui/material";
import type React from "react";

type ActionCardProps = {
  icon: React.ReactNode;
  title: string;
  details: string;
  onClick?: () => void;
};

const ActionCard = ({ icon, title, details, onClick }: ActionCardProps) => {
  return (
    <Card
      className="rounded-2xl"
      sx={{ border: "1px solid #e5e5e5", boxShadow: "none" }}
      onClick={onClick}
    >
      <CardContent className="flex flex-col items-center justify-center text-center px-2 py-4">
        <div className="mb-2 bg-background-action text-primary-active rounded-4xl size-14 flex flex-row items-center justify-center">
          {icon}
        </div>
        <Typography variant="subtitle2" className="font-semibold">
          {title}
        </Typography>
        <Typography variant="caption" color="text.secondary" className="mb-1">
          {details}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ActionCard;
